import type { Material, MeshStandardMaterial, Object3D } from "three";
import { Mesh } from "three";

const TEXTURE_KEYS: (keyof MeshStandardMaterial)[] = [
    "map",
    "normalMap",
    "roughnessMap",
    "metalnessMap",
    "aoMap",
    "emissiveMap",
    "envMap",
    "lightMap",
    "bumpMap",
    "displacementMap",
    "alphaMap",
];

function disposeMaterial(material: Material) {
    TEXTURE_KEYS.forEach((key) => {
        const texture = (material as MeshStandardMaterial)[key];
        if (texture && typeof texture === "object" && "dispose" in texture && typeof texture.dispose === "function") {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            texture.dispose();
        }
    });

    material.dispose();
}

export default function disposeChild(child: Object3D) {
    if (!(child instanceof Mesh)) return;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
    child.geometry.dispose();

    if (Array.isArray(child.material)) {
        child.material.forEach(disposeMaterial);
    } else {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        disposeMaterial(child.material);
    }
}
